import { ConfigProvider, DatePicker, Space } from "antd";
import ptBR from "antd/es/locale/pt_BR";
import React from "react";
import styled from "styled-components";

import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
dayjs.extend(customParseFormat);

function DataRangerPicker({
  handleChange,
  input,
  size,
  disabledDate,
  width,
  minWidth,
}) {
  return (
    <Space direction="vertical" style={{ width: "100%" }}>
      <ConfigProvider locale={ptBR}>
        <DatePicker.RangePicker
          value={input && input}
          size={size ? size : "small"}
          name="period"
          format="DD/MM/YYYY"
          disabled={disabledDate}
          onChange={handleChange}
          panelRender={(panelNode) => (
            <StyledRangePickerContainer>{panelNode}</StyledRangePickerContainer>
          )}
          locale={ptBR}
          className="responsive-range-picker"
          style={{
            width: width || "100%",
            minWidth: minWidth || "250px",
          }}
        />
      </ConfigProvider>
    </Space>
  );
}

const StyledRangePickerContainer = styled.div`
  @media (max-width: 576px) {
    .ant-picker-panels {
      flex-direction: column !important;
      items-align: center !important;
    }
  }
`;

export default DataRangerPicker;
